export const TYPES_UPDATE_INTEGRANTES_COMISION = {
    OPEN_MODAL: 'OPEN_MODAL',
    ADD_MEMBER: 'ADD_MEMBER',
    SET_MEMBERS: 'SET_MEMBERS',
    SET_POSITIONS: 'SET_POSITIONS',
    SET_COMMISSIONS: 'SET_COMMISSIONS',
    SET_STATUS_RESPONSE: 'SET_STATUS_RESPONSE',
    SET_SELECTED_COMMISSION: 'SET_SELECTED_COMMISSION',
}